import UserMdThinIcon from '../../assets/icons/user_md_thin.svg';
import RecordMedicalIcon from '../../assets/icons/record_medical.svg';
import HouseBlankIcon from '../../assets/icons/house_blank.svg';
import MyVisitsIcon from '../../assets/icons/my_visits.svg';
import DoctorVisitIcon from '../../assets/icons/doctor_visit.svg';
import { CustomNavLink } from '../route-handler/customNav';

export const Footer = () => {
  return (
    <ul className="footer-icons h-14 bg-[var(--rs-primary-500)] flex justify-around text-xs text-[--rs-white]">
      <li>
        {' '}
        <CustomNavLink to="/examination" title="بخش معاینه" icon={UserMdThinIcon} />
      </li>
      <li>
        {' '}
        <CustomNavLink to="/examinations" title="معاینات من" icon={RecordMedicalIcon} />
      </li>
      <li>
        <CustomNavLink to="/feed" title="خانه" icon={HouseBlankIcon} />
      </li>
      <li>
        {' '}
        <CustomNavLink to="/my-visits" title="نوبت های من" icon={MyVisitsIcon} />
      </li>
      <li>
        {' '}
        <CustomNavLink to="/expertise" title="گرفتن نوبت" icon={DoctorVisitIcon} />
      </li>
    </ul>
  );
};
